<div class="cdialog">
  <div class="dialogHeader">
    <h2 mat-dialog-title>{{title}}</h2>
    <div class="spacer"></div>
    <div (click)="cancel()" class="closeButton">
      <fa-icon icon="times"></fa-icon>
    </div>

  </div>
  <mat-dialog-content>
    <div class="dialogBody">
      {{prompt}}
      <div>
        {{filename}}

      </div>
      <input type="file" #fileNode style="display:none;" (change)="updateFile()" />
      <button class="app-btn btn-outline" (click)="fileNode.click(); updateFile()">
        {{_common?.select ?? 'Select'}}
      </button>

    </div>
  </mat-dialog-content>
  <div class="dialogBar">
    <!-- <button class="app-btn btn-text" (click)="cancel()">
      {{_common?.cancel ?? 'Cancel'}}
    </button> -->
    <div class="spacer"></div>
    <button class="app-btn" (click)="upload()" color="primary">
      {{_common?.upload ?? 'Upload'}}
    </button>

  </div>
</div>